import { useQuery } from '@tanstack/react-query';
import { auditLogsApi } from '../api/endpoints/auditLogs';
import type { GetAuditLogsParams, GetEntityAuditParams } from '../types/auditLog';

export function useAuditLogs() {
  const useTenantLogs = (params: GetAuditLogsParams) =>
    useQuery({
      queryKey: ['admin-tenant-audit', params],
      queryFn: () => auditLogsApi.getTenantLogs(params).then((r) => r.data)
    });

  const useEntityLogs = (params: GetEntityAuditParams) =>
    useQuery({
      queryKey: ['admin-entity-audit', params],
      queryFn: () => auditLogsApi.getEntityLogs(params).then((r) => r.data)
    });

  return { useTenantLogs, useEntityLogs };
}

export async function exportAuditCsv(params: GetAuditLogsParams) {
  const res = await auditLogsApi.exportCsv(params);
  const url = URL.createObjectURL(new Blob([res.data], { type: 'text/csv' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = `audit-export-${new Date().toISOString().split('T')[0]}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
